import { render } from "./DemoStructure.vue?vue&type=template&id=388fe8a4&scoped=true&ts=true"
import script from "./DemoStructure.vue?vue&type=script&lang=ts"
export * from "./DemoStructure.vue?vue&type=script&lang=ts"

import "./DemoStructure.vue?vue&type=style&index=0&id=388fe8a4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388fe8a4"]])

export default __exports__